module.exports = __webpack_public_path__ + "media/svg/hk-16b893ce.svg";